<template>
  <div>
    <b-sidebar
      :id="sbId"
      :visible="sbModel"
      sidebar-class="feedback-sidebar"
      width="35%"
      bg-variant="dark"
      text-variant="light"
      right
      shadow
      @change="handleSideBarChange"
    >
      <template #title>
        <close-button @close-button-click="handleCloseSideBar" />
      </template>
      <template #header-close>
        Send us feedback
      </template>
      <div style="padding:15px">
        <p>Describe your feedback</p>
        <b-form-textarea
          id="textarea"
          style="
            background-color: #343b40;
            border-style: solid;
            border-color: whitesmoke;
            color: white"
          v-model="form.feedback"
          placeholder="Tell us what prompted this feedback..."
          rows="3"
          max-rows="6"
        />
        <small>
          Please don't include any sensitive information.
        </small>
        <template v-if="false">
          <p style="margin-top: 25px;">
            A screenshot will help us better understand your feedback.
            (optional)
          </p>
          <b-button block>
            Capture screenshot
          </b-button>
        </template>
        <p>
          We may email you for more information or updates
        </p>
      </div>
      <template #footer>
        <b-row>
          <b-col>
            <div style="margin: 15px;">
              <b-form-checkbox size="md" v-model="form._canCollectMsg">
                Allow {{ myApp ? myApp : "HeartBeatFam" }} to collect my
                conversation history from this session and submit it with my
                feedback.
              </b-form-checkbox>
              <b-form-checkbox
                size="md"
                v-model="form._canEmail"
                style="margin-top: 15px;"
              >
                We may email you for more information or updates
              </b-form-checkbox>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col style="margin: 15px;">
            Some account and system information may be sent to HeatBeatFam. We
            will use it to fix problems and improve our services, subject to our
            <b-link @click="handlePolicyPrivacyClick">Privacy Policy</b-link>
            and
            <b-link @click="handlePolicyTermsClick">Terms of Service</b-link> .
            We may email you for more information or updates. Go to Legal Help
            to ask for content changes for legal reasons.
          </b-col>
        </b-row>
        <hr style="font-weight: bold" />
        <b-row>
          <b-col>
            <div class="d-flex bg-dark text-light align-items-center px-3 py-2">
              <strong class="mr-auto">
                &nbsp;
              </strong>
              <b-button size="lg" @click="handleSubmitFeedback">
                Send
              </b-button>
            </div>
          </b-col>
        </b-row>
      </template>
    </b-sidebar>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import _ from "lodash";
import CloseButton from "@/components/common/closeButton";
import axios from "axios";
export default {
  name: "Form_Feedback_Sidebar",
  components: {
    CloseButton
  },
  props: {
    sbId: {
      type: String,
      required: true
    },
    sbModel: {
      type: Boolean,
      required: true
    },
    profile: {
      type: Object,
      required: true,
      default: () => {
        return {};
      }
    },
    myApp: {
      type: String,
      default: null
    }
  },
  created() {},
  mounted() {
    this.handleResetForm();
  },
  computed: {
    ...mapGetters({})
  },
  methods: {
    handleCloseSideBar() {
      this.$emit("close-clicked");
    },
    handleSubmitFeedback() {
      let createdBy = this.profileBy();

      axios.get("https://api.ipify.org?format=json").then(res => {
        let ip = res.data.ip;
        this.$store
          .dispatch("admin/addFeedback", {
            form: this.form,
            ip: ip,
            createdBy: createdBy
          })
          .then(res => {
            this.$store.dispatch("user/showNotification", {
              title: `Feedback Submitted`,
              description: `Thanks for your submission.`,
              variant: "success"
            });

            this.handleCloseSideBar();
          });
      });
    },
    handleSideBarChange() {
      debugger;
      this.handleResetForm();
    },
    handlePolicyPrivacyClick() {
      const route = "/policy/privacy";
      window.open(route, "_blank");
    },
    handlePolicyTermsClick() {
      const route = "/policy/terms";
      window.open(route, "_blank");
    },
    handleResetForm() {
      this.form = _.clone(this.formDefault);
    },
    profileBy() {
      if (this.profile) {
        return {
          uid: this.profile && this.profile.userId ? this.profile.userId : null,
          name: this.profile
            ? `${this.profile.firstname} ${this.profile.lastname}`
            : null,
          imgURL: this.profile ? this.profile.imgURL : null
        };
      }
      //Sessions
      return null;
    }
  },
  data() {
    return {
      form: {},
      formDefault: {
        feedback: null,
        myApp: this.myApp ? this.myApp : null,
        urlPath: this.$route && this.$route.path ? this.$route.path : null,
        _canCollectMsg: true,
        _canEmail: true
      },
      feedback: "",
      activeTabIdx: 0,
      selectedHeartBeat: null,
      messagesBox: null,
      sidebarFooterHeight: 3000,
      messageBoxRefId: "message-box",
      momentTest: null,
      collectionRef: null,
      unsub: null,
      messages: [],
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 40,
        height: 40,
        class: "m1"
      }
    };
  }
};
</script>

<style lang="scss" scoped></style>
